import React, { Component } from "react";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
} from "mdbreact";
import MetaTags from "react-meta-tags";
// import calendarnormal1 from "../assets/calendar/calendarnormal1.png";
// import calendarnormal2 from "../assets/calendar/calendarnormal2.png";
// import calendarnormal3 from "../assets/calendar/calendarnormal3.png";
// import calendarnurse from "../assets/calendar/calendarnurse.png";
import Normall1 from "../assets/2025/2.png";
import Normall2 from "../assets/2025/4.png";
import Normall3 from "../assets/2025/5.png";
import Normall4 from "../assets/2025/6.png";
import Normall5 from "../assets/2025/7.png";
import { Image, Pane, Text } from "evergreen-ui";
///2026
import ROB1 from "../assets/2026/calendar/1.png";
import ROB2 from "../assets/2026/calendar/2.png";
import ROB3 from "../assets/2026/calendar/3.png";
import ROB4 from "../assets/2026/calendar/4.png";
import ROB5 from "../assets/2026/calendar/5.png";
import ROB6 from "../assets/2026/calendar/6.png";
import ROB7 from "../assets/2026/calendar/7.png";

export default class Calendars extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    document.body.style.background = "#f4efe6";
    document.body.style.background =
      "linear-gradient(90deg, #f3c36b 0%, #f5b536 50%, #fdb306 100%)";
    document.body.style.background = "#ebebebff";
    // document.body.style.backgroundColor = "blue";
  }
  render() {
    return (
      <>
        <MetaTags>
          <title>ปฏิทินการรับสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="ปฏิทินการรับสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร Calendar's Kamphaeng Phet Rajabhat University"
          />
          <meta property="og:title" content="ปฏิทินการรับสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร" />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <MDBContainer fluid>
          <MDBRow>
            <MDBCol lg="1" md="1" sm="1"></MDBCol>
            <MDBCol lg="10" md="10" sm="10">
              <>
                <MDBCardBody>
                  <MDBCardTitle className="text-align ">
                    <Text style={{ fontSize: "28px", fontWeight: 800 }}>ปฏิทินการรับสมัคร</Text>
                  </MDBCardTitle>
                  <MDBCardText>
                    <div>
                      <Text
                        style={{
                          fontSize: "clamp(8px,24px,4vw)",
                          fontWeight: 500,
                          margin: "auto",
                        }}
                      >
                        {" "}
                        ระดับปริญญาตรี ภาคปกติ (จันทร์-ศุกร์){" "}
                      </Text>{" "}
                      <br />
                    </div>
                    <Pane
                      display="flex"
                      justifyContent="center"
                      flexWrap="wrap"
                      flexDirection="row"
                    >
                      <div className="p-2 col-md-4">
                        <Image
                          src={ROB1}
                          width="100%"
                          boxShadow="2px 5px 8px #00000040"
                          borderRadius={8}
                        />
                      </div>
                      <div className="p-2 col-md-4">
                        <Image
                          src={ROB2}
                          width="100%"
                          boxShadow="2px 5px 8px #00000040"
                          borderRadius={8}
                        />
                      </div>
                      <div className="p-2 col-md-4">
                        <Image
                          src={ROB3}
                          width="100%"
                          boxShadow="2px 5px 8px #00000040"
                          borderRadius={8}
                        />
                      </div>
                      <div className="p-2 col-md-4">
                        <Image
                          src={ROB4}
                          width="100%"
                          boxShadow="2px 5px 8px #00000040"
                          borderRadius={8}
                        />
                      </div>
                      <div className="p-2 col-md-4">
                        <Image
                          src={ROB5}
                          width="100%"
                          boxShadow="2px 5px 8px #00000040"
                          borderRadius={8}
                        />
                      </div>
                      <div className="p-2 col-md-4">
                        <Image
                          src={ROB6}
                          width="100%"
                          boxShadow="2px 5px 8px #00000040"
                          borderRadius={8}
                        />
                      </div>
                      <div className="p-2 col-md-4">
                        <Image
                          src={ROB7}
                          width="100%"
                          boxShadow="2px 5px 8px #00000040"
                          borderRadius={8}
                        />
                      </div>
                      <div className="p-2 col-md-4"></div>
                      <div className="p-2 col-md-4"></div>
                    </Pane>
                  </MDBCardText>
                </MDBCardBody>
              </>
            </MDBCol>
            <MDBCol lg="1" md="1" sm="1"></MDBCol>
          </MDBRow>
        </MDBContainer>
      </>
    );
  }
}
